module.exports = __webpack_public_path__ + "img/floppy-disk.14d454b0.svg";